import React from "react";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { NavDrawer } from "./NavDrawer";
import { NavData } from "@/features/nav/NavItem";

export interface MobileNavProps {
  customerName?: string;
  accountLink?: string;
  mobileNavdata: NavData[];
}

const MobileNav = ({
  customerName,
  accountLink,
  mobileNavdata,
}: MobileNavProps) => {
  const [open, setOpen] = React.useState(false);

  const handleNavClose = () => {
    setOpen(false);
  };

  return (
    <div className="flex">
      <CssBaseline />
      <Toolbar style={{ minHeight: "48px", padding: 0, width: 0 }}>
        <IconButton
          className="transition hover:opacity-50"
          color="inherit"
          aria-label="open navigation drawer"
          edge="end"
          tabIndex={0}
          onClick={() => setOpen(true)}
          size="large"
        >
          <MenuIcon style={{ color: "hsl(var(--color-primary))" }} />
        </IconButton>
        {/* not sure why we have an empty heading here */}
        <Typography
          variant="h6"
          noWrap
          role="presentation"
          aria-hidden="true"
          tabIndex={-1}
          className="grow"
        />
      </Toolbar>
      <NavDrawer
        links={mobileNavdata}
        open={open}
        onClose={handleNavClose}
        customerName={customerName}
        accountLink={accountLink}
        isRoot={true}
        title=""
      />
    </div>
  );
};

export { MobileNav };
